import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../src/environments/environment';
import { UsersubscriptionModel } from './usersubscription.model';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { ReactiveServiceWithFilters } from '../reactive-service-with-filters.abstract';

@Injectable()
export class UsersubscriptionsApiService
  extends ReactiveServiceWithFilters
  implements Resolve<UsersubscriptionModel[]>
{
  protected baseUrl =
    environment.backEndUrlPrefix + '/' + 'db/user/profile/event';

  constructor(protected http: HttpClient) {
    super();
  }

  getAll(
    userId?: number,
    subscribedOnly?: string,
  ): Observable<UsersubscriptionModel[]> {
    const params = subscribedOnly ? { subscribedOnly } : {};
    /*  SEM-5116 из реста убрали фильтр    const params = new HttpParams().append('notify', 'true');
      return this.http.get<UsersubscriptionModel[]>(this.buildUrl(this.baseUrl), {params});*/
    return this.http.get<UsersubscriptionModel[]>(this.buildUrl(this.baseUrl), {
      params,
    });
  }

  updateGroupAll(ids: number[], data): Observable<any> | any {
    const rlist = [];
    data.forEach((_d) => {
      rlist.push(this.http.put(`${this.baseUrl}`, _d));
    });
    return forkJoin(rlist);
  }

  updateGroup(ids: number[], data): Observable<any[]> {
    if (!Array.isArray(ids)) {
      ids = [ids];
    }
    return this.http.patch<any[]>(
      environment.backEndUrlPrefix + '/' + 'db/user/profile/event',
      data,
      { params: { id: ids.map((id) => id.toString()) } },
    );
  }

  deleteGroup(ids: number[]): Observable<string> {
    return this.http.delete<string>(this.baseUrl, {
      params: { id: ids.map((id) => String(id)) },
    });
  }

  saveGroup(ids: number[]): Observable<string> {
    return this.http.put<string>(this.baseUrl, ids);
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<UsersubscriptionModel[]>
    | Promise<UsersubscriptionModel[]>
    | UsersubscriptionModel[] {
    return this.getAll(
      undefined,
      JSON.stringify(route.data?.options?.notify || false),
    );
  }

  isSubscrided(item: UsersubscriptionModel) {
    if (item.sound) {
      return true;
    }
    for (const a of item.methods) {
      if (a.subscribed) {
        return true;
      }
    }
    return false;
  }
}
